module.exports = __webpack_public_path__ + "static/media/freelancer-highlight-4.35414bc8.webp";